import httpClientService from '../httpClientService';

export default {
	getEntities: () => httpClientService.Get('/DataImportModule/api/Entity'),

	getImportFiles: (opts) =>
		httpClientService.Get(
			`/DataImportModule/api/ImportFile?page=${opts.page}&rows=${opts.rowsPerPage}&filter=${opts.filter}`
		),

	insertFile: (param) =>
		httpClientService.PostMultiPart(
			'/DataImportModule/api/ImportFile',
			param
		),

	getAvailableTemplates: () =>
		httpClientService.Get('/DataImportModule/api/GridViews/Templates'),
	getDefaultGridViews: () =>
		httpClientService.Get('/DataImportModule/api/GridViews/Defaults'),
	getTemplates: () =>
		httpClientService.Get('/DataImportModule/api/GridViews'),
	insertTemplate: (item) =>
		httpClientService.Post('/DataImportModule/api/GridViews', item),
	updateTemplate: (item) =>
		httpClientService.Put(
			`/DataImportModule/api/GridViews/${item.Id}`,
			item
		),
	deleteTemplate: (id) =>
		httpClientService.Delete(`/DataImportModule/api/GridViews/${id}`),

	getTemplateFields: (id) =>
		httpClientService.Get(
			'/DataImportModule/api/ImportGridViewFields?id=' + id
		),
	getReferenceListTypes: () =>
		httpClientService.Get('/DataImportModule/api/RefrenceListType'),
	getDataFields: () =>
		httpClientService.Get('/DataImportModule/api/DataField'),
	getGridViewById: (id) =>
		httpClientService.Get('/DataImportModule/api/GridViews?id=' + id),

	updateColumns: (data) => {
		return httpClientService.Put(
			'/DataImportModule/api/ImportGridViewFields/UpdateColumns',
			data
		);
	},

	uploadImportTemplateFields: (param) =>
		httpClientService.PostMultiPart(
			'/DataImportModule/api/ImportGridViewFields/ImportTemplateFieldsUpload',
			param
		),
	insertTemplateField: (field) =>
		httpClientService.Post(
			'DataImportModule/api/ImportGridViewFields',
			field
		),
	updateTemplateField: (field) =>
		httpClientService.Put(
			`/DataImportModule/api/ImportGridViewFields/${field.Id}`,
			field
		),
	deleteTemplateField: (field) =>
		httpClientService.Delete(
			`/DataImportModule/api/ImportGridViewFields/${field.Id}`
		),
};
